import { COMPANY_MANAGER } from "utils/constants/UserRoles";

const useNonOwnerCompanyManagers = (users) => {
	return users
		?.filter((user) => user?.role?.name === COMPANY_MANAGER && !user?.is_owner)
		?.map((companyManager) => ({
			...companyManager,
			full_name: `${companyManager?.first_name} ${companyManager?.last_name}`,
		}));
}

export default useNonOwnerCompanyManagers;